import localforage from "localforage";

import {
    apiUrl as rootUrl,
    apiVersion
} from "../../config";

export async function addUser (
    { phone,  }
) {
    const body = {
        phone,
        "mode": "phone",
        "twoFactorAuth": false
    };

    const token = await localforage.getItem("nakamian.admin-token");
    const response = await fetch(
        `${ rootUrl }/${ apiVersion }/user/register`,
        {
            "method": "POST",
            "mode": "cors",
            "headers": {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${ token }`
            },
            "body": JSON.stringify(body),
        }
    );

    if (response.ok) {
        const user = await response.json();
        if (user) {
            return user;
        }
        throw "Register error";
    }

    if (response.status >= 400) {
        throw await response.text();
    }

    throw "Internal server error";
}

export default addUser;
